import type { ReactNode } from "react";
import { usePageHeader } from "../../../components/shell/PageHeaderContext";
import { useKuspitOverview } from "../../../lib/queries";
import { SubNav } from "../shared";

export const KUSPIT_BASE = "/admin/kuspit";

/** Header + section tabs shared by every Kuspit screen; badges come from the (polled) overview. */
export function KuspitFrame({ title, subtitle, actions, children }: { title: string; subtitle: string; actions?: ReactNode; children: ReactNode }) {
  usePageHeader(title, subtitle, actions);
  const overview = useKuspitOverview();
  const data = overview.data;
  return (
    <div className="page-container">
      <SubNav
        ariaLabel="Secciones de Kuspit"
        items={[
          { to: KUSPIT_BASE, label: "Estado", end: true },
          { to: `${KUSPIT_BASE}/contratos`, label: "Contratos", count: data ? data.sync.failed + data.wallets.pendingStuck : null },
          { to: `${KUSPIT_BASE}/webhooks`, label: "Webhooks", count: data ? data.notifications.byStatus.failed + data.notifications.byStatus.received : null },
          { to: `${KUSPIT_BASE}/llamadas`, label: "Llamadas", count: data ? data.calls24h.errors : null }
        ]}
      />
      {children}
    </div>
  );
}

export const shortId = (value: string | null | undefined, keep = 8) => (value ? value.slice(0, keep) : "—");
